import type { ReactNode } from 'react'
import { Icon, type IconName } from './icons/Icon'

export type AlertSeverity = 'error' | 'warning' | 'info' | 'success'

const ICON_BY_SEVERITY: Record<AlertSeverity, IconName> = {
  error: 'alert-circle',
  warning: 'alert-triangle',
  info: 'info',
  success: 'check-circle',
}

export interface InlineAlertProps {
  severity: AlertSeverity
  children: ReactNode
  action?: ReactNode
}

/**
 * `role="alert"` for errors (per design-system.md §3.1 Toast/InlineAlert —
 * announced immediately); other severities are `role="status"` (polite).
 */
export function InlineAlert({ severity, children, action }: InlineAlertProps) {
  return (
    <div
      className={`iw-inline-alert iw-inline-alert--${severity}`}
      role={severity === 'error' ? 'alert' : 'status'}
    >
      <Icon name={ICON_BY_SEVERITY[severity]} size={18} />
      <div style={{ flex: 1 }}>{children}</div>
      {action}
    </div>
  )
}
